module.exports = __webpack_public_path__ + "img/cert2.ef24124d.png";